export default "__VITE_PUBLIC_ASSET__c42fbe87__"